/* this file has common styles for consistency */
//https://blog.logrocket.com/the-best-styling-in-react-tutorial-youve-ever-seen-676f1284b945/

// Replicated from theme
const theme = {
  spacing(num) {
    return 8 * num;
  }
}

//for use on second and subsequent section titles
const sectionTitle = {
    marginTop: 15,
    marginBottom: 3
} 

//for use on first section title
const sectionTitleFirst = {
  marginBottom: 3
}

//for use on section title when above a table
const sectionTitleTable = {
    marginTop: 15,
    marginBottom: -8
}

const boldLabel = {
  fontWeight: 500
}

const fullScreenDialogTitle = {
  padding: "0",
  marginBottom: "32px",
  fontSize: "24px",
  fontWeight: "500",
  textAlign: "center"
}

const fullScreenDialogTitleCenter = {
  padding: "0",
  marginBottom: "32px",
  fontSize: "24px",
  fontWeight: "500",
  textAlign: "center"
}

//for use on pagination widget div (Margin bottom allows it to not overlap with chat widget)
const paginationTableFooter = {
  marginTop: 10,
  marginBottom: 42
}

// this style is used for all bottom buttons: save, disable, delete, deactivate, etc
const bottomButton = {
  marginTop: 16,
  marginBottom: 0,
  marginRight: 16
}

// this style is used for all bottom buttons: save, disable, delete, deactivate, etc
const bottomRightAlignedButton = {
  marginTop: 16,
  marginBottom: 0,
  marginRight: 8
}

// these styles are used for bottom buttons (save, disable, delete, deactivate, etc) in
// paper sections
const bottomButtonPaper12 = {
  marginTop: 12,
  marginBottom: 0,
  marginRight: 16
}
const bottomButtonPaper8 = {
  marginTop: 8,
  marginBottom: 0,
  marginRight: 16
}
const bottomButtonPaper6 = {
  marginTop: 6,
  marginBottom: 0,
  marginRight: 16
}
const bottomButtonPaper4 = {
  marginTop: 4,
  marginBottom: 0,
  marginRight: 16
}

//this style is used for the bottom bar
const bottomBar = {
  backgroundColor: '#e5e5e5',
  height: 48,
  top: 'auto',
  bottom: 0,
}

//this style used for all bottom bar buttons: save, disable, delete, deactivate, etc
const bottomBarButton = {
  marginTop: 0,
  marginBottom: 16,
  marginRight: 16
}

//this style is used for buttons on search screens (e.g. customers, app catalog)
const addButtonOnSearch = {
  marginTop: 16
}

// search container on paper with searches
const searchContainerOnPaper = {
  marginTop: 0,
  marginBottom: 16
}

// search field
const searchField = {
  marginRight: theme.spacing(1),
  marginTop: 0,
  marginBottom: 0,
  width: 300
}

const searchField240 = {
  marginRight: theme.spacing(1),
  marginTop: 0,
  marginBottom: 0,
  width: 240
}

const searchField224 = {
  marginRight: theme.spacing(1),
  marginTop: 0,
  marginBottom: 0,
  width: 224
}

const searchField160 = {
  marginRight: theme.spacing(1),
  marginTop: 0,
  marginBottom: 0,
  width: 160
}

// date picker field
const datePickerField = {
  width: 130
}

const datePickerMessageMax = 'Future date is invalid';

// markup description line used on SO and "buy subscription"
const markupDescription = {
  marginTop: -4,
}

const tipPaper = {
  marginTop: 16,
  padding: 16,
}

const tableHead = {
  backgroundColor: '#f1f1f1'
}

const tableHeadRow = {
  height: 24
}

const AppBindStyles = {
    paginationTableFooter:       paginationTableFooter,
    fullScreenDialogTitle:       fullScreenDialogTitle,
    fullScreenDialogTitleCenter: fullScreenDialogTitleCenter,
    sectionTitle:                sectionTitle,
    sectionTitleFirst:           sectionTitleFirst,
    sectionTitleTable:           sectionTitleTable,
    boldLabel:                   boldLabel,
    bottomButton:                bottomButton,
    bottomButtonPaper12:         bottomButtonPaper12,
    bottomButtonPaper8:          bottomButtonPaper8,
    bottomButtonPaper6:          bottomButtonPaper6,
    bottomButtonPaper4:          bottomButtonPaper4,
    bottomRightAlignedButton:    bottomRightAlignedButton,
    bottomBar:                   bottomBar,
    bottomBarButton:             bottomBarButton,
    searchContainerOnPaper:      searchContainerOnPaper,
    addButtonOnSearch:           addButtonOnSearch,
    searchField:                 searchField,
    searchField240:              searchField240,
    searchField224:              searchField224,
    searchField160:              searchField160,
    datePickerField:             datePickerField,
    datePickerMessageMax:        datePickerMessageMax,
    markupDescription:           markupDescription,
    tipPaper:                    tipPaper,
    tableHead:                   tableHead,
    tableHeadRow:                tableHeadRow
}


export default (AppBindStyles);